/**
 * Shallowly compares the own enumerable properties of two values, in insertion order and by
 * reference. Works for plain objects and arrays alike, and treats `null`/`undefined` as equal
 * to each other and unequal to any other value.
 *
 * @param a - the first value to compare
 * @param b - the second value to compare
 * @returns `true` when both values are falsy, or when they have the same own enumerable keys
 * with reference-equal values
 */
export const shallowEqual = (a, b) => {
    if (!a && !b) {
        return true;
    }
    if (!a || !b) {
        return false;
    }
    const aRecord = a;
    const bRecord = b;
    const aKeys = Object.keys(aRecord);
    if (aKeys.length !== Object.keys(bRecord).length) {
        return false;
    }
    return aKeys.every(key => aRecord[key] === bRecord[key]);
};
